import { TZDate } from "@date-fns/tz";

export function timestampToDate(timestamp: number, timezone?: string | null) {
  return timezone
    ? new TZDate(timestamp).withTimeZone(timezone)
    : new Date(timestamp);
}

export const getDateString = (d: Date) => d.toISOString().split("T")[0];
